import { FC } from 'react';
import { Stars } from 'tedooo-web-design-system/ui';

import { Span } from 'components/helpers';
import { translations } from 'translations/en';
import { toFormat } from 'utils';

export interface IReviewInformation {
  avg: number;
  totalReviews: number;
}

const ReviewInformation: FC<IReviewInformation> = ({ avg, totalReviews }) => {
  const isOneReview = totalReviews === 1;

  const reviewsText = isOneReview ? translations.COMMON.REVIEW : translations.COMMON.REVIEWS;

  const reviews = `${totalReviews} ${reviewsText}`;

  const formattedAvg = toFormat(avg, 2);

  return (
    <div className="review-information">
      <Span text={formattedAvg} className="title" />
      <Stars value={avg} size="small" />
      <Span text={reviews} className="text" />
    </div>
  );
};

export default ReviewInformation;
